import * as Yup from 'yup'

export const adminProfileSchema = Yup.object().shape({
  firstName: Yup.string().min(3, 'First Name must be atleast 3 characters')
    .max(200)
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'Only Alphabets and Space Allowed and Must Start with Alphabet')
    .required('First Name Required'),
  lastName: Yup.string().min(3, 'Last Name must be atleast 3 characters')
    .max(200)
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'Only Alphabets and Space Allowed and Must Start with Alphabet')
    .required('Last Name Required'),
  phone: Yup.string()
    .min(10, 'Phone must be at least 10 digits')
    .max(20, 'Phone must be at most 20 digits')
    .matches(
      /^((\\+[1-9]{1,10}[ \\-]*)|(\\([0-9]{1,10}\\)[ \\-]*)|([0-9]{1,10})[ \\-]*)*?[0-9]{1,10}?[ \\-]*[0-9]{1,10}?$/,
      'Enter a valid Phone Number'
    )
})

export const adminConfigSchema = Yup.object().shape({
  DEPOSIT_TRANSACTION_TIME_LIMIT: Yup.number()
    .typeError('Must be a number')
    .required('Value Required')
    .min(0, 'Cannot be negative'),
  LOW_WALLET_AMOUNT: Yup.number()
    .typeError('Must be a number')
    .required('Value Required')
    .min(0, 'Cannot be negative'),
  MAXIMUM_DEPOSIT_LIMIT: Yup.number()
    .typeError('Must be a number')
    .required('Value Required')
    .min(0, 'Cannot be negative'),
  WITHDRAWAL_IN_CASH: Yup.string()
    .required('Value Required')
    .oneOf(['true', 'false'], 'Must be either enable or disable'),
  WHATSAPP_NUMBER: Yup.string()
    .matches(
      /^(?:\+?\d{1,4}[\s-]?)?(?:\(?\d{2,5}\)?[\s-]?)?\d{3,5}[\s-]?\d{3,5}$/,
      'Must be a valid phone number'
    )
    .required('Phone number is required'),
})




export const socialConfigSchema = Yup.object().shape({
  FACEBOOK_LINK: Yup.string()
    .required('Facebook link is required'),

  TIKTOK_LINK: Yup.string()
    .required('TikTok link is required'),

  TWITTER_LINK: Yup.string()
    .required('Twitter link is required'),

  YOUTUBE_LINK: Yup.string()
    .required('YouTube link is required'),

  INSTAGRAM_LINK: Yup.string()
    .required('YouTube link is required'),
});


// Yup validation schema for all bonus fields with unique keys
export const bonusConfigSchema = Yup.object().shape({
  freebet_wager_amount: Yup.number()
    .typeError("Wager amount must be a number")
    .required("Wager amount is required"),
  freebet_no_of_free_bet: Yup.number()
    .typeError("Number of free bets must be a number")
    .required("Number of free bets is required")
    .integer("Number of free bets must be an integer")
    .positive("Number of free bets must be positive"),
  freebet_bonus_amount: Yup.number()
    .typeError("Bonus amount must be a number")
    .required("Bonus amount is required"),
  freebet_is_active: Yup.string()
    .required("Active status is required")
    .oneOf(["true", "false"], "Invalid active status"),
  deposit_bonus_amount: Yup.number()
    .typeError("Bonus amount must be a number")
    .required("Bonus amount is required")
    .min(1, "Bonus amount must be at least 1")
    .max(100, "Bonus amount cannot exceed 100"),
  deposit_is_active: Yup.string()
    .required("Active status is required")
    .oneOf(["true", "false"], "Invalid active status"),
  cashback_bonus_amount: Yup.number()
    .typeError("Bonus amount must be a number")
    .required("Bonus amount is required")
    .positive("Bonus amount must be positive"),
  cashback_is_active: Yup.string()
    .required("Active status is required")
    .oneOf(["true", "false"], "Invalid active status"),
  cashback_no_of_cashback_bet: Yup.number()
    .typeError("Number of cashback bets must be a number")
    .required("Number of cashback bets is required")
    .integer("Number of cashback bets must be an integer")
    .positive("Number of cashback bets must be positive"),
  cashback_wager_amount: Yup.number()
    .typeError("Wager amount must be a number")
    .required("Wager amount is required"),
  rfb_bonus_amount: Yup.number()
    .typeError("RFB Bonus must be a number")
    .required("RFB Bonus is required")
    .positive("RFB Bonus must be positive")
    .integer("RFB Bonus must be an integer"),
  rfb_thresold: Yup.number()
    .typeError("RFB threshold must be a number")
    .required("RFB threshold is required")
    .positive("RFB threshold must be positive")
    .integer("RFB threshold must be an integer"),
  rfb_no_of_rfb: Yup.number()
    .typeError("Number of RFBs must be a number")
    .required("Number of RFBs is required")
    .integer("Number of RFBs must be an integer")
    .positive("Number of RFBs must be positive"),
  rfb_is_active: Yup.string()
    .required("Active status is required")
    .oneOf(["true", "false"], "Invalid active status"),
  crfb_thresold: Yup.number()
    .typeError("CRFB threshold must be a number")
    .required("CRFB threshold is required")
    .positive("CRFB threshold must be positive")
    .integer("CRFB threshold must be an integer"),
  crfb_no_of_crfb: Yup.number()
    .typeError("Number of CRFBs must be a number")
    .required("Number of CRFBs is required")
    .integer("Number of CRFBs must be an integer")
    .positive("Number of CRFBs must be positive"),
  crfb_is_active: Yup.string()
    .required("Active status is required")
    .oneOf(["true", "false"], "Invalid active status"),
});

export const adminSiteConfigSchema = Yup.object().shape({
  name: Yup.string().min(3, 'Name must be atleast 3 characters')
    .max(200).required('Name Required'),
  url: Yup.string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
    )
    .required('Url Required'),
  // supportEmail: Yup.string().email('Invalid Email').max(50).required('Email Required'),
  // sendgridEmail: Yup.string().email('Invalid sendgridEmail').max(50).required('sendgridEmail Required'),
  // sendgridKey:Yup.string().required('sendgridKey Required'),
  // logo:  Yup.mixed().test('File Size',
  // 'File Size Should be Less Than 1MB', (value) => !value || (value && value.size <= 1024 * 1024))
  // .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
  //   (value) => !value || (value && ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type))),
  // lang:Yup.mixed().required('Language Required'),
})
export const profilePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Old Password Required!'),
  newPassword: Yup.string()
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //   'Invalid Password'
    // )
    .test('match', 'Old and New Password Must be Different!', function (newPassword) {
      return newPassword !== this.options.parent.password
    })
    .max(50)
    .required('New Password Required!'),
  confirmPassword:
    Yup.string()
      .max(50)
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match!')
      .required('Confirm Password Required!')
})
